import { createFileRoute } from '@tanstack/react-router'
import { NotesPage } from '@/components/notes-page'
export const Route = createFileRoute('/labels/$labelId')({ component: LabelNotes })
function LabelNotes() { const { labelId } = Route.useParams(); return <NotesPage view={`label:${labelId}`} /> }
